import api from './api';

export const adminService = {
  // Buscar todos os usuários (apenas para super-admin)
   getAllUsers: async () => {
    try {
      const response = await api.get('/admin/usuarios');
      return response.data.usuarios;
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
      
      if (error.response?.status === 403) {
        throw new Error('Acesso não autorizado. Apenas o administrador pode visualizar esta página.');
      }
      
      throw new Error(error.response?.data?.error || 'Erro ao buscar usuários');
    }
  },
  
  // Buscar um usuário específico
  getUserById: async (userId) => {
    try {
      const response = await api.get(`/admin/usuarios/${userId}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar usuário ${userId}:`, error);
      throw new Error(error.response?.data?.error || 'Erro ao buscar dados do usuário');
    }
  },
  
  // Desativar um usuário
  deactivateUser: async (userId) => {
    try {
      const response = await api.put(`/admin/usuarios/${userId}/desativar`);
      return response.data;
    } catch (error) {
      console.error('Erro ao desativar usuário:', error);
      throw new Error(error.response?.data?.error || 'Erro ao desativar usuário');
    }
  },

  // Ativar um usuário
  activateUser: async (userId) => {
    try {
      const response = await api.put(`/admin/usuarios/${userId}/ativar`);
      return response.data;
    } catch (error) {
      console.error('Erro ao ativar usuário:', error);
      throw new Error(error.response?.data?.error || 'Erro ao ativar usuário');
    }
  },
  
  // Buscar todos os grupos
  getAllGroups: async (params = {}) => {
    try {
      const response = await api.get('/admin/grupos', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar grupos:', error);
      throw new Error(error.response?.data?.error || 'Erro ao buscar grupos');
    }
  },
  
  // Buscar estatísticas gerais do sistema
  getStatistics: async () => {
    try {
      const response = await api.get('/admin/estatisticas');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
      throw new Error(error.response?.data?.error || 'Erro ao buscar estatísticas do sistema');
    }
  },
  
  // Verificar se o usuário atual é super-admin
  checkSuperAdmin: async () => {
    try {
      // Tenta acessar um endpoint protegido, que retornará 403 se não for super-admin
      const response = await api.get('/admin/usuarios', { 
        timeout: 5000,
        validateStatus: function (status) {
          // Considera 200 como sucesso (é admin) e 403 como falha (não é admin)
          return status === 200 || status === 403;
        } 
      });
      
      // Se retornou 200, é super admin
      return response.status === 200;
    } catch (error) {
      // Se houver problemas de conexão ou outro erro, assumimos que não é admin
      console.error("Erro ao verificar permissões de super admin:", error);
      return false;
    }
  }
};
